import { useAppConfig } from '../../appConfig'
import { useQueryString } from '../../navigation'
import { usePromoCode } from './promoCodes.hooks'

/**
 * get the promo code to apply by default
 * this can come from the currenct plaform of from the query params
 */
export const useDefaultPromoCode = () => {
  const { data: appConfig } = useAppConfig()
  const customCoupon = useQueryString('coupon')

  const {
    promoCode: platformPromoCode,
    editableByCustomer = true,
  } = appConfig?.platform?.promoCode ?? {}

  const {
    data: customPromoCode,
    loading: loadingCustomCoupon,
  } = usePromoCode(customCoupon, { skip: !editableByCustomer })

  if (customPromoCode) {
    return {
      promoCode: customPromoCode,
      fromPlatform: false,
    }
  }

  if (platformPromoCode && !loadingCustomCoupon) {
    return {
      promoCode: platformPromoCode,
      fromPlatform: true,
    }
  }

  return {
    promoCode: undefined,
    fromPlatform: false,
  }
}
